import React from "react";
import "./styles.scss";
import error404 from "../../images/error404.jpg";
import { Link } from "react-router-dom";

const NotFoundPage = () => {
  return (
    <div className="comp-wrap NotFoundPage">
      <div className="comp-cont flex-it flex-align-item-center flex-justify-center">
        <div className="auto">
          <Link to="/" className="logo" aria-label="logo">
            Back to Site
          </Link>
          <div className="error-message">
            Page not found <br />
            <img src={error404} alt="error" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
